import * as React from "react";

function SvgIcons8Staff(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M16 9c-2.75 0-5 2.25-5 5 0 1.516.707 2.863 1.781 3.781a7.062 7.062 0 00-2.656 2.407C9.223 18.878 7.707 18 6 18c-2.758 0-5 2.242-5 5h8v1h2c0-2.773 2.227-5 5-5s5 2.227 5 5h2v-1h8c0-2.758-2.242-5-5-5-1.707 0-3.223.879-4.125 2.188a7.062 7.062 0 00-2.656-2.407C20.293 16.863 21 15.516 21 14c0-2.75-2.25-5-5-5zm10 9a3 3 0 10-.002-6.002A3 3 0 0026 18zM6 18a3 3 0 10-.002-6.002A3 3 0 006 18zm10-7c1.668 0 3 1.332 3 3s-1.332 3-3 3-3-1.332-3-3 1.332-3 3-3z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Staff);
